/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Api_UnauthenticatedInputs */

const fr_api_unauthenticated = /** @type {(inputs: Api_UnauthenticatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Votre session est terminée. Reconnectez-vous pour continuer.`)
};

const en_api_unauthenticated = /** @type {(inputs: Api_UnauthenticatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your session has ended. Sign in again to continue.`)
};

/**
* | output |
* | --- |
* | "Your session has ended. Sign in again to continue." |
*
* @param {Api_UnauthenticatedInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const api_unauthenticated = /** @type {((inputs?: Api_UnauthenticatedInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Api_UnauthenticatedInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_api_unauthenticated(inputs)
	return fr_api_unauthenticated(inputs)
});